class BeeBundleProduct
{
   constructor(section_id, products, settings)
   {
      this.section_id = section_id;
      this.products = products;
      this.settings = settings;
      this.adding = false;
      this.init();
   }

   init = () =>
   {
      console.log('section ID', this.section_id);
      console.log('products', this.products);
      console.log('settings', this.settings);
      this.setListeners();
   }

   addProductsToCart = async (el) =>
   {
      try
      {
         if (!this.adding)
         {
            this.adding = true;
            el.classList.add('adding-to-cart');
            let items = [];
            const properties = {
               bundle_tag: this.settings.tag,
               min_bundle_qty: this.settings.min_quantity
            }
            this.products.forEach(product =>
            {
               let args = {
                  id: product.variants[0]?.id,
                  quantity: product.handle === 'fusilloni' ? 2 : 1,
                  properties: properties
               }
               items.push(args);
            })
            const response = await fetch('/cart/add.js', {
               method: 'POST',
               headers: {
                  'Content-Type': 'application/json'
               },
               body: JSON.stringify({ items: items })
            }).then(response => response.json());

            if (response)
            {
               window.location.href = '/cart';
            }
         }
      } catch (error)
      {
         this.adding = false;
         console.log(error.message);
      }
   }

   setListeners = () =>
   {
      const addToCartBtn = document.getElementById(`bundle-product-add-${this.section_id}`);

      if (addToCartBtn)
      {
         addToCartBtn.addEventListener('click', () => this.addProductsToCart(addToCartBtn));
      }

   }
}